import {Department} from '../master-data/master-data.model';

export enum DocType {
  JPG,
  PNG,
  PDF
}

export enum FileType {
  DIRECTORY = 1,
  FILE = 2
}

export enum LibraryType {
  PUBLIC= 0,
  PERSONAL = 1

}

export class FileNode {
  uuid: string;
  name: string;
  type: FileType;
  children: FileNode[];
}

export const DocTypeMap: Record<DocType, string> = {
  [DocType.JPG]: 'jpg',
  [DocType.PNG]: 'png',
  [DocType.PDF]: 'pdf',
};



export class LibraryDocument {
  uuid?: string;
  type: DocType;
  name: string;
  directory: LibraryDirectory;
  departments: Department[];
  externalId?: string;
  created: number;
  path: string;
  fileSize: number;
  libraryType: LibraryType;
  constructor(libraryType: LibraryType) {
    this.libraryType = libraryType;
  }

}

export class LibraryDirectory {
  uuid: string;
  name: string;
  parent: LibraryDirectory | null;
  type: LibraryType;
  externalId: string;
  relatedObjectUuid: string;

  constructor(libType: LibraryType) {
    this.type = libType;
  }
}


export class LibraryDocumentCreateCommand {
  name: string;
  type: DocType;
  departmentsUuids: string[];
  directoryUuid: string;
  externalId: string;
}

export class LibraryDirectoryCreateCommand {
  name: string;
  parentUuid: string;
  externalId: string;
  type: LibraryType;
  relatedObjectUuid: string;
}

export class LibraryDirectoryEditCommand {
  uuid: string;
  name: string;
  parentUuid: string;
  relatedObjectUuid: string;
}

export class ChangeDirectoryCommand {
  uuid: string;
  directoryUuid: string;

}

export class LibraryDocumentEditCommand {
  uuid: string;
  name: string;
  departmentsUuids: string[];
  directoryUuid: string;
  externalId: string;
}


